export default __webpack_public_path__ + "static/media/portfolio-hover-202.452f4190.jpg";